export const EXPORT_SPONSOR_URL =
  "https://plump-plastic.com/bT3rVT0.PK3Mp_vEbim/VrJUZ/Dv0N3FMczvU/3BNCTwEG3sLETOcRznN/TccG1/M_jsEs";

export function runSponsoredExport(
  exportAction,
  openWindow = (url, target, features) => window.open(url, target, features)
) {
  openWindow(EXPORT_SPONSOR_URL, "_blank", "noopener,noreferrer");
  return exportAction();
}
